export default __webpack_public_path__ + "static/blootropic-logo-colored-seo-thumbnail-4831661b5cdaec42badc0ffc5acea73c.png";